<div class="main">
    <div class="cont">
        <div id="light"></div>
        <div class="col-xs-12" id="content">
            
            <div class="col-xs-6">
               <h1>Down left corner</h1>
            </div>
            <div class="col-xs-6">
                <h1>up right corner</h1>
            </div>
            <div class="cent">
                <h2>Top left corner</h2>
            </div>
            <div class="downleft">
                <h2>Up center</h2>
            </div>
            <div class="upright">
                <h2>down center</h2>
            </div>
            <div class="downcent">
                <h2>bottom right corner</h2>
            </div>
            <div class="bottomright">
                <p><b>Obsessive-compulsive disorder (OCD):</b> People with OCD are plagued by constant thoughts or fears that cause them to perform certain rituals or routines. 
                    An example is a person with an unreasonable fear of germs who constantly washes their hands.<p>
            </div>
        </div>
    </div>
</div>